<ng-container *transloco="let t; read: 'acc-text-input'">
  @if (label()) {
    <label class="font-normal-semibold" [for]="id()">
      <span>
        {{ label() }}
        @if (requirementLabel()) {
          <span class="font-xxs-semibold">
            {{ t(requirementLabel()) }}
          </span>
        }

        @if (tooltip()) {
          <accredible-icon icon="info" [accredibleTooltip]="tooltip()" />
        }
      </span>
    </label>
  }

  @if (hint()) {
    <div class="hint font-s-regular">
      {{ hint() }}
    </div>
  }

  <div
    class="input-wrapper"
    [class.has-icon]="!!icon()"
    [class.has-reset]="showReset() && !!formControlRef().value?.length"
    [class.error]="formControlRef().invalid"
    [ngClass]="iconPosition() + '-icon'">
    <input
      #textInput
      class="font-normal-regular"
      [ngClass]="size()"
      [class.has-icon]="!!icon()"
      [type]="inputType()"
      [id]="id()"
      [placeholder]="placeholder()"
      [readOnly]="readonly()"
      [formControl]="formControlRef()"
      [required]="required() || isFormControlRequired()"
      [autocomplete]="autoComplete()"
      [attr.maxLength]="type() !== 'number' ? maxLength() || null : null"
      [min]="min()"
      [max]="max()"
      [attr.data-cy]="
        dataCy() ? dataCy() : label() ? label().split(' ').join('-').toLowerCase() + '-input' : null
      "
      [attr.aria-describedby]="
        formControlRef().touched && formControlRef().invalid && !noError() ? id() + '-error' : null
      "
      (blur)="onBlur($event)" />

    @if (icon()) {
      <accredible-icon
        class="input-icon"
        [class.clickable-icon]="isClickable"
        [icon]="icon()"
        [attr.role]="isClickable ? 'button' : null"
        [attr.tabIndex]="isClickable ? '0' : '-1'"
        (keydown.enter)="isClickable ? iconClick.emit(true) : null"
        (keydown.space)="isClickable ? iconClick.emit(true) : null"
        (click)="isClickable ? iconClick.emit(true) : null" />
    }

    @if (type() === 'password') {
      <button
        [attr.data-cy]="
          label() ? label().split(' ').join('-').toLowerCase() + '-input-toggle-visibility' : null
        "
        (click)="togglePasswordVisibility($event)">
        <accredible-icon
          class="password-toggle-icon clickable-icon"
          [class.error]="formControlRef().touched && formControlRef().invalid"
          [icon]="isPasswordVisible() ? 'hide' : 'view'" />
      </button>
    }

    @if (showReset() && iconPosition() !== 'end' && !!formControlRef().value?.length) {
      <accredible-icon
        role="button"
        tabindex="0"
        class="reset-icon clickable-icon"
        icon="close-small"
        (click)="formControlRef().reset('')" />
    }
  </div>

  @if (!noError()) {
    <div
      class="feedback-message"
      [id]="id() + '-error'"
      aria-live="polite"
      aria-atomic="true"
      aria-relevant="additions removals">
      @if (formControlRef().touched) {
        <ng-content select="accredible-input-feedback" />
      }
    </div>
  }
</ng-container>
